import { render, staticRenderFns } from "./NoDataWithChips.vue?vue&type=template&id=34d1077c&"
import script from "./NoDataWithChips.vue?vue&type=script&lang=js&"
export * from "./NoDataWithChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports